<template>
  <div class="welcome-container">
    <!-- 动态背景 -->
    <div class="dynamic-background"></div>

    <!-- 欢迎标题和介绍 -->
    <div class="welcome-header">
      <h1>Welcome to <span class="brand">t-notes</span></h1>
      <p class="subtitle">Your all-in-one solution for notes, cloud storage, and AI-powered productivity.</p>
    </div>

    <!-- 功能卡片 -->
    <div class="feature-cards">
      <div class="feature-card" @click="navigateToNotes">
        <div class="feature-icon">
          <i class="fas fa-book"></i>
        </div>
        <h2>Notes</h2>
        <p>Organize your ideas effortlessly with our intuitive note-taking tools.</p>
        <div class="feature-badge">Collaboration Ready</div>
      </div>
      <div class="feature-card" @click="navigateToCloud">
        <div class="feature-icon">
          <i class="fas fa-cloud"></i>
        </div>
        <h2>Cloud Storage</h2>
        <p>Securely store and access your files from anywhere, anytime.</p>
      </div>
      <div class="feature-card" @click="navigateToAI">
        <div class="feature-icon">
          <i class="fas fa-robot"></i>
        </div>
        <h2>AI Assistant</h2>
        <p>Boost your productivity with AI-powered insights and automation.</p>
      </div>
    </div>

    <!-- 快速开始按钮 -->
    <div class="quick-start">
      <button class="start-button" @click="navigateToQuickStart">
        <i class="fas fa-rocket"></i>
        <span>Get Started</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
  methods: {
    navigateToNotes() {
      if (localStorage.getItem("userInfo") == null) {
        this.$router.push('/login');
      }
      this.$router.push('/home/mine');
    },
    navigateToCloud() {
      if (localStorage.getItem("userInfo") == null) {
        this.$router.push('/login');
      }
      this.$router.push('/home/cloud/index');
    },
    navigateToAI() {
      if (localStorage.getItem("userInfo") == null) {
        this.$router.push('/login');
      }
      this.$router.push('/home/mine');
    },
    navigateToQuickStart() {
      if (localStorage.getItem("userInfo") == null) {
        this.$router.push('/login');
      }
      this.$router.push('/home/quickstart');
    },
  },
};
</script>

<style scoped>
.welcome-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #0f0f1a;
  color: #ffffff;
  padding: 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.dynamic-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, #1e1e3a 0%, #0f0f1a 100%);
  z-index: 0;
  animation: pulseBackground 10s infinite alternate;
}

@keyframes pulseBackground {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1.05);
  }
}

.welcome-header {
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
  animation: fadeInDown 1.5s ease-out;
}

.welcome-header h1 {
  font-size: 4.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.welcome-header .brand {
  color: #8b5cf6;
  text-shadow: 0 0 10px rgba(139, 92, 246, 0.7);
}

.welcome-header .subtitle {
  font-size: 1.3rem;
  color: #a1a1aa;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
  animation: fadeInUp 2s ease-out;
}

.feature-cards {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
  animation: fadeInUp 2.5s ease-out;
}

.feature-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 32px;
  width: 300px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.2) 0%, transparent 70%);
  transform: scale(0);
  transition: transform 0.5s ease;
}

.feature-card:hover::before {
  transform: scale(1);
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.15);
}

.feature-icon {
  font-size: 3rem;
  color: #8b5cf6;
  margin-bottom: 16px;
  animation: float 3s ease-in-out infinite;
}

.feature-card h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
}

.feature-card p {
  font-size: 1rem;
  color: #a1a1aa;
  line-height: 1.6;
}

.feature-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #8b5cf6;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
}

.quick-start {
  margin-top: 40px;
  position: relative;
  z-index: 1;
  animation: fadeInUp 3s ease-out;
}

.start-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  background: #8b5cf6;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.start-button:hover {
  background: #7c3aed;
  transform: scale(1.05);
}

.start-button i {
  font-size: 1.2rem;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>